import { gql } from '@apollo/client';

export const nearbyCitiesQuery = gql`
  query NearbyCities($slug: String!) {
    providerLandingRelatedCities(slug: $slug) {
      id
      slug
      name
    }
  }
`;

type City = {
  id: string;
  name: string;
  slug: string;
};

export type NearbyCitiesResponse = {
  providerLandingRelatedCities: City[];
};
